// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2so_2","box":"WorkspacesBox_box__1o_zu","node":"WorkspacesBox_node__2e68W"};